import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownLabelWrapper = styled<any, any>(
    'label',
    'filterDropdownLabelWrapper',
    'filterItemDropdown'
)`
    ${propStyles};
`;

export default FilterDropdownLabelWrapper;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdownLabelWrapper.tsx